/**
 * Foundation floor path utilities - extracted to break circular dependency
 * between stemWall.ts, foundationSuperSystem.ts, and slab.ts
 */
import type { FloorPath } from "building-types/floors/floorTypes";
import type { SheathingComponentEntity } from "building-types/floors/sheathingComponentTypes";
import type { SlabComponentEntity } from "building-types/floors/slabComponentTypes";
import { SlabType } from "building-types/foundations/foundationEnums";
import type { FoundationPath } from "building-types/foundations/foundationTypes";
import type { FramingComponentEntity } from "building-types/framing/framingComponentTypes";
import type { Level } from "building-types/levels/levelTypes";
import type { SlabSettings } from "building-types/settings/foundationSettingsTypes";
import type { Table } from "common/data/table";
import { floorPathBottom, floorPathTop } from "../floor/floorPathUtils";
import { slabDepthAtFoundationPath, slabTypeAtFoundationPath } from "./slabUtils";

export function foundationPathSuperSystemBottom({
  foundationPath,
  floorPath,
  level,
  slabSettings,
  framingComponents,
  slabComponents,
  sheathingComponents,
}: {
  foundationPath: Pick<FoundationPath, "condition">;
  floorPath: Pick<FloorPath, "floorPriority" | "leftRoom" | "rightRoom" | "leftFloorAssembly" | "rightFloorAssembly">;
  level: Level;
  slabSettings: SlabSettings | undefined;
  framingComponents: Table<FramingComponentEntity>;
  slabComponents: Table<SlabComponentEntity>;
  sheathingComponents: Table<SheathingComponentEntity>;
}) {
  const top = floorPathTop(level, floorPath);

  const slabType = slabTypeAtFoundationPath({ condition: foundationPath.condition }, slabSettings);
  const slabDepth = slabDepthAtFoundationPath({ condition: foundationPath.condition }, slabSettings);

  if (slabType !== SlabType.NONE && slabDepth !== 0) {
    const BOSlab = top - slabDepth;
    return BOSlab;
  }

  const BOFloorPlate = floorPathBottom(level, floorPath, framingComponents, slabComponents, sheathingComponents);
  return BOFloorPlate;
}
